var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99219 4.33496C9.42611 3.88864 10.1296 3.88864 10.5635 4.33496C10.9973 4.78129 10.9974 5.50489 10.5635 5.95117L5.79395 10.8574H20.8887C21.5023 10.8574 22 11.3688 22 12C22 12.6312 21.5023 13.1426 20.8887 13.1426H5.79395L10.5635 18.0488C10.9974 18.4952 10.9974 19.2187 10.5635 19.665C10.1295 20.1113 9.42606 20.1113 8.99219 19.665L2.33594 12.8184C2.28112 12.7634 2.23234 12.7023 2.18945 12.6367C2.17837 12.6198 2.16831 12.6023 2.1582 12.585C2.11372 12.5084 2.07702 12.4266 2.05078 12.3398L2.0459 12.3252C2.04127 12.3091 2.03811 12.2926 2.03418 12.2764C2.01278 12.1878 2 12.0954 2 12C2 11.9061 2.01146 11.8149 2.03223 11.7275C2.04548 11.6718 2.06345 11.6171 2.08496 11.5635C2.10584 11.5116 2.13043 11.4618 2.1582 11.4141C2.20422 11.335 2.25993 11.2595 2.32617 11.1914L8.99219 4.33496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowWhite);
export default __webpack_public_path__ + "static/media/BACK_ARROW_WHITE.da74bb177623fac542dafa1dd763160d.svg";
export { ForwardRef as ReactComponent };